import { ErrorMessage, useField } from 'formik';
import { PropTypes } from 'prop-types';

export const MyTextInput = ( { label, ...props } ) => {

    const [ field ] = useField(props)

    return (
        <>
            <label htmlFor={ props.id || props.name }>{ label }</label>
            <input className="text-input" { ...field } { ...props } />
            <ErrorMessage name={ props.name } component="em" />
        </>
    )
}
MyTextInput.propTypes = {
    label: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
}
